const fetchReportOfJobOfferListFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.jobOfferList = action.payload.data.data;
	state.currentPage = action.payload.data.current_page;
	state.perPage = action.payload.data.limit;
	state.totalPages = action.payload.data.total_pages;
	state.totalJobOfferReports = action.payload.data.total_count;
	state.lastUpdated = action.payload.data.last_updated;
	state.message = action.payload.message;
};

const fetchReportOfInsuranceListFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.insuranceReportList = action.payload.data.data;
	state.insuranceCurrentPage = action.payload.data.current_page;
	state.insurancePerPage = action.payload.data.limit;
	state.insuranceTotalPages = action.payload.data.total_pages;
	state.totalInsuranceReports = action.payload.data.total_count;
	state.insuranceLastUpdated = action.payload.data.last_updated;
}

const fetchReportOfContractListFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.contractReportList = action.payload.data.data;
	state.contractCurrentPage = action.payload.data.current_page;
	state.contractPerPage = action.payload.data.limit;
	state.contractTotalPages = action.payload.data.total_pages;
	state.totalContractReports = action.payload.data.total_count;
	state.contractLastUpdated = action.payload.data.last_updated;
}

const fetchJobOfferCreatedByListFulfilled = (state, action) => {
	state.status = 'succeeded';
	state.jobOfferCreatedByList = action.payload.data;
}

export {
	fetchReportOfJobOfferListFulfilled,
	fetchReportOfInsuranceListFulfilled,
	fetchReportOfContractListFulfilled,
	fetchJobOfferCreatedByListFulfilled
};
